<template>
  <div :class="`grid-container ${gridClass}`">
    <BreadcrumbsComponent id="v-breadcrumbs"></BreadcrumbsComponent>
    <div id="v-description" v-html="categoryDescription" class="category-description-wrapper" v-if="categoryDescription"></div>
    <div id='v-pills' :class='hideFilters'><PillsFilter v-model="filterPills" @remove="store.removePill"></PillsFilter></div>
    <div v-if="!isMobileSize" id='sidebar' :class='hideSidebar' >
      <div id='v-filters' :class='hideFilters' ><FiltersComponent></FiltersComponent></div>
      <div id='v-promotions' class='hidePromotions' ><PromotionsComponent></PromotionsComponent></div>
    </div>
    <template v-else>
      <div id='v-filters' :class='hideFilters' >
        <q-expansion-item v-model="expanded" expand-separator label="FILTER" class="overflow-hidden" style="border-radius: 4px" header-class="bg-primary text-white" expand-icon-class="text-white">
          <FiltersComponent></FiltersComponent>
        </q-expansion-item>
      </div>
      <div id='v-promotions' :class='hidePromotions'><PromotionsComponent></PromotionsComponent></div>
    </template>
    <div id="results">
      <q-slide-transition>
      <div id="v-products" v-if='isProductSearch'><ProductResultsTable></ProductResultsTable></div>
      </q-slide-transition>
      <q-slide-transition>
        <div id="v-knowledge" v-if='isArticleSearch'><KBaseResultsTable></KBaseResultsTable></div>
      </q-slide-transition>
    </div>
    <q-resize-observer @resize="onResize" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import BreadcrumbsComponent from './BreadcrumbsComponent.vue';
import PillsFilter from './filters/PillsFilter.vue';
import PromotionsComponent from './Promotions.vue';
import KBaseResultsTable from './KBaseResultsTable.vue';
import ProductResultsTable from './ProductResultsTable/index.vue';
import FiltersComponent from './FiltersSection.vue';
import { useFilterStore } from '../stores/filter-store';
import { storeToRefs } from 'pinia';
import { usePromotionStore } from '../stores/promotion-store';

const promotionsStore = usePromotionStore();
const { promotionCount } = storeToRefs(promotionsStore);

const store = useFilterStore();
const { filterPills, isProductSearch, isArticleSearch, categoryDescription, filterCount } = storeToRefs(store);


let isMobileSize = ref(false);
let expanded = ref(false);

const onResize = ({ width }) => {
    if (width < 768) isMobileSize.value = true;
    else isMobileSize.value = false;
}

const hideFilters = computed(() => {
    if (!filterCount.value) return 'hide-filters';
    return '';
})

const hidePromotions = computed(() => {
    if (!promotionCount.value) return 'hide-promotions';
    return '';
})

const hideSidebar = computed(() => {
    if (hideFilters.value && hidePromotions.value) return 'hide-sidebar';
    return '';
})
const gridClass = computed(() => {
    if (hideFilters.value && hidePromotions.value) return 'hide-both';
    if (hideFilters.value) return 'hide-filters';
    if (hidePromotions.value) return 'hide-promotions';
    return '';
})
</script>

<style lang="scss" scoped>
#v-description {
  grid-area: description;
}
#v-breadcrumbs {
  grid-area: crumbs;
}
#v-pills {
  grid-area: pills;
}
#v-filters {
  grid-area: filters;
}
#v-promotions {
    grid-area: promos;
    
    display: grid;
    grid-gap: 14px;
    padding-bottom: 20px;
}
#v-products {
  grid-area: products;
  margin-bottom: 40px;
}
#v-knowledge {
  grid-area: kbase;
  margin-bottom: 70px;
}
#sidebar {
  grid-area: side;
}
#results {
  grid-area: results;
}

.grid-container {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: calc(5vw - 30px) 255px calc(90vw - 302px) calc(5vw - 30px);
  grid-column-gap: 30px;
  grid-row-gap: 10px;
  grid-template-areas:
    'crumbs crumbs crumbs crumbs'
    '. description description .'
    '.      pills  pills   .'
    '.      side   results .'
    '.      side   .       .';

  &.hide-promotions {
    grid-template-areas:
      'crumbs crumbs crumbs crumbs'
      '. description description .'
      '.      pills  pills   .'
      '.      side   results .'
      '.      side   .       .';
  }

  &.hide-both {
    grid-template-areas:
      'crumbs crumbs crumbs crumbs'
      '. description description .'
      '.     results results     .';
  }

  &.hide-filters {
    grid-template-areas:
      'crumbs crumbs crumbs crumbs'
      '. description description .'
      '.      side   results .'
      '.      side   .       .';
  }
}

@media only screen and (max-width: 767px) {
  .grid-container {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 15px auto 15px; /* 1 column */
    grid-column-gap: 0;
    grid-row-gap: 10px;
    grid-template-areas:
      'crumbs crumbs crumbs'
      '. description .'
      '. pills    .'
      '. filters  .'
      '. results  .'
      '. promos   .';
    
    &.hide-promotions {
      grid-template-areas:
        'crumbs crumbs crumbs'
        '. description .'
        '. pills    .'
        '. filters  .'
        '. results  .';
    }
    &.hide-both {
      grid-template-areas:
        'crumbs crumbs crumbs'
        '. description .'
        '. results  .';
    }
    &.hide-filters {
      grid-template-areas:
        'crumbs crumbs crumbs'
        '. description .'
        '. results  .'
        '. promos   .';
    }
  }
}

.category-description-wrapper {
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 15px;
}

#v-pills.hide-filters,
#v-filters.hide-filters,
#v-promotions.hide-promotions,
#sidebar.hide-sidebar {
  display: none;
}
</style>
